import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { routeReplacer, createQueriedURL } from '~/Helpers/String.helper';
import {
  CORE_SERVICE_URLS,
  EVENT_SERVICE_URLS,
  eventServiceUrls,
} from '~/Constants/Urls.constants';
import { EventGroup } from '~/Models/DTO/EventGroup.model';
import { createRequestAction } from '~/Helpers/Action.helpers';
import { EventListQuery } from '~/store/events';
import { IBulkRequest } from '~/Hooks';

export const requestUpdateEventGroup = (query: Partial<EventGroup>) =>
  createRequestAction({
    name: REQUEST_ACTIONS.PATCH_EVENTGROUP,
    url: routeReplacer(EVENT_SERVICE_URLS.EVENT_GROUPS, { eventGroupId: query.id || '' }),
    data: query,
    method: 'PATCH',
  });

export const requestCreateEventGroup = (query: EventGroup) =>
  createRequestAction({
    name: REQUEST_ACTIONS.POST_EVENTGROUP,
    url: EVENT_SERVICE_URLS.EVENT_GROUPS,
    data: query,
    method: 'POST',
  });

export const requestEventGroupList = (query: {
  active?: boolean;
  public?: boolean;
  archived?: boolean;
  providerId: string;
  trainerIds?: string[];
  locationsIds?: string[];
  categoryTypes?: string[];
}) => {
  // delete all the undefined values from the query object
  Object.keys(query).forEach(
    (key) => (query as any)[key] === undefined && delete (query as any)[key],
  );
  return createRequestAction({
    name: REQUEST_ACTIONS.GET_EVENTGROUP_LIST,
    url: createQueriedURL(EVENT_SERVICE_URLS.EVENT_GROUPS, query),
    method: 'GET',
  });
};

export const requestSyncedEventGroups = ({ providerId }: EventListQuery) =>
  createRequestAction({
    name: REQUEST_ACTIONS.GET_SYNCED_EVENT_GROUP_LIST,
    url: createQueriedURL(CORE_SERVICE_URLS.SYNCED_EVENT_GROUPS, { providerId }),
    method: 'GET',
  });

export const requestNextEventsByEventGroupIds = ({
  providerId,
  eventGroupIds,
  from,
}: {
  providerId: string;
  eventGroupIds: string[];
  from: Date;
}) => {
  const bulkRequests: IBulkRequest[] = eventGroupIds.map((id, index) => ({
    requestId: String(index),
    method: 'GET',
    path: eventServiceUrls.EVENT_LIST,
    query: {
      providerId,
      eventGroupId: id,
      from,
      size: 1,
    },
  }));

  return createRequestAction({
    name: REQUEST_ACTIONS.GET_NEXT_EVENTS,
    url: EVENT_SERVICE_URLS.BULK,
    method: 'POST',
    data: bulkRequests,
  });
};
